import React from 'react';

import {OdontoConfirmationBooking} from 'presentation/modules/booking/odonto/ui/pages/OdontoConfirmationBooking';

export const MakeOdontoConfirmationBooking = () => {
	return <OdontoConfirmationBooking />;
};
